import * as api from "app/api/planning"
import { Conflict } from "app/models/timeslot"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as planningTimeslotsActions from "../planningTimeslots/planningTimeslots.actions"
import * as actions from "./planningConflicts.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* patchConflicts(action: actions.PatchConflictsAction): SagaIterator {
  try {
    const { status, timeslotId, conflictId } = action.payload
    const response = yield call(api.patchConflicts, timeslotId, conflictId, status)
    const patchedConflict = response && (response.data as Conflict)
    if (patchedConflict) {
      yield put(planningTimeslotsActions.patchTimeslotConflictSuccess(timeslotId, patchedConflict))
    }
  } catch (e) {
    yield put(actions.patchConflictsFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* planningConflictsSaga(): SagaIterator {
  yield takeLatest(actions.Types.PATCH, patchConflicts)
}
